import axios from 'axios' 
import router from '../router'

let root = '/exam_online_interface'

function apiAxios (method, url,params) {
  let token = window.document.cookie.match('(^|;) ?token-dongdu=([^;]*)(;|$)');
  token = token ? token[2] : null;
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: root+url,
      data: method === 'POST' ? params : null,
      params: method === 'GET' ? params : null,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Request-From' : '0',
        'token-dongdu':window.sessionStorage.id == null ? null:token,
        'loginName': window.sessionStorage.getItem('loginName'),
        'companyId': window.sessionStorage.getItem('companyId'),
      },
      withCredentials: true,
    })
      .then(
        function (response) {
          let data = response.data;
          if (data) {
            let messageString = "";
            if (!data.meta.success) {
              if (data.meta.message) {
                messageString = data.meta.message + "<br />";
              }
              if (data.validateErrorList && data.validateErrorList.length > 0) {
                for ( let i in data.validateErrorList) {
                  messageString += data.validateErrorList[i].validateMessage
                    + "<br />";
                }
              }
              reject(response);
              console.log(`do ajax ${url} failed`);
              router.replace("/home/errApi");
            } else {
              resolve(response.data);
            }
          }
        },
        function(res){
          if(res.response.status == 401){
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            window.sessionStorage.clear();
            localStorage.clear();
            router.replace("/home/index");
            window.sessionStorage.setItem("isLogOutUser", true);
            window.location.reload();
          } else if(res.response.status == 410){
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            var oel = window.sessionStorage.getItem("online_exam_language");
            window.sessionStorage.clear();
            localStorage.clear();
            router.replace("/home/index");
            window.sessionStorage.setItem("isDeleteUser", true);
            window.sessionStorage.setItem("online_exam_language", oel);
            window.localStorage.setItem("online_exam_language", oel);
            window.location.reload();
          } else if (res.response.status == 403) {
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            var oel = window.sessionStorage.getItem("online_exam_language");
            window.sessionStorage.clear();
            localStorage.clear();
            router.replace("/home/index");
            window.sessionStorage.setItem("online_exam_language", oel);
            window.localStorage.setItem("online_exam_language", oel);
            window.sessionStorage.setItem("isLogoutUserLoginFlag", true);
            window.location.reload();
          } else if(res.response.status == 404 || res.response.status == 500){
            if (params.redirectFlag == 0) {
              reject(res);
            } else {
              router.replace("/home/err");
            }
          }
          reject(res);
        }).catch((error) => {
          reject(error.message);
        });
  })
}

function apiAxiosForFormData (method, url,params) {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: root+url,
      data: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'loginName': window.sessionStorage.getItem('loginName'),
        'companyId': window.sessionStorage.getItem('companyId'),
      }
    })
      .then(
        function (response) {
          let data = response.data;
          if (data) {
            let messageString = "";
            if (!data.meta.success) {
              if (data.meta.message) {
                messageString = data.meta.message + "<br />";
              }
              if (data.validateErrorList && data.validateErrorList.length > 0) {
                for ( let i in data.validateErrorList) {
                  messageString += data.validateErrorList[i].validateMessage
                    + "<br />";
                }
              }
              reject(response);
            } else {
              resolve(response.data);
            }
          }
        },
        function(res){
          if(res.response.status == 410){
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            var oel = window.sessionStorage.getItem("online_exam_language");
            window.sessionStorage.clear();
            localStorage.clear();
            router.replace("/home/index");
            window.sessionStorage.setItem("isDeleteUser", true);
            window.sessionStorage.setItem("online_exam_language", oel);
            window.localStorage.setItem("online_exam_language", oel);
            window.location.reload();
          } else if (res.response.status == 403) {
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            var oel = window.sessionStorage.getItem("online_exam_language");
            window.sessionStorage.clear();
            localStorage.clear();
            router.replace("/home/index");
            window.sessionStorage.setItem("online_exam_language", oel);
            window.localStorage.setItem("online_exam_language", oel);
            window.sessionStorage.setItem("isLogoutUserLoginFlag", true);
            window.location.reload();
          }
          reject(res);
        }).catch((error) => {
          reject(error.message);
        });
  })
}

export default {
  get: function (url,params) {
    return apiAxios('GET', url, params)
  },
  post: function (url, params) {
    return apiAxios('POST', url, params)
  },
  form : function (url, params) {
    return apiAxiosForFormData('POST', url, params)
  }
}



// WEBPACK FOOTER //
// ./src/util/axios.js